import classNames from "classnames";
import { FormField } from "components/Forms/FormField";
import { LyneFormField } from "components/Lyne/LyneFormField";
import { createLogger } from "logging";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

import { HookFormError } from "./HookFormError";

const logger = createLogger("HookForm:TextArea");

interface HookFormTextAreaProps<TFieldValues extends FieldValues, TName extends Path<TFieldValues>> extends FormField {
  name: TName;
  control: Control<TFieldValues, unknown, TFieldValues>;
  maxLength?: number;
}

export const HookFormTextArea = <TFieldValues extends FieldValues, TName extends Path<TFieldValues>>(
  props: HookFormTextAreaProps<TFieldValues, TName>
) => {
  const { name, control, maxLength, required, label, contextHelp } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field, fieldState }) => {
        const { onChange, onBlur, value, ref } = field;

        const { isDirty, isTouched, error } = fieldState;
        const className = classNames(
          isDirty ? "is-dirty" : "",
          isTouched ? "is-touched" : "",
          error ? "is-error" : "",
          required && isTouched && !value ? "sbb-invalid" : ""
        );
        logger.trace(`${name}: state`, className);

        return (
          <LyneFormField name={name} required={required} label={label} contextHelp={contextHelp}>
            <textarea
              className={className}
              ref={ref}
              name={name}
              value={value}
              autoComplete="off"
              maxLength={maxLength}
              onBlur={(e) => {
                logger.trace(`${name}: onBlur(): `, e.target.value);
                onBlur();
              }}
              onChange={(e) => {
                logger.trace(`${name}: onChange(): `, e.target.value);
                onChange(e);
              }}
            />
            <HookFormError error={error} />
          </LyneFormField>
        );
      }}
    />
  );
};
